import {useTileAnimation, type TileProps} from './types'

export const Tile2 = ({className, colors, delay}: TileProps) => {
  const svgRef = useTileAnimation({
    delay,
    selector: 'rect',
    scaleProperty: 'scale',
    transformOrigin: '0% 100%',
  })

  return (
    <svg
      ref={svgRef}
      className={className}
      width="400"
      height="146"
      viewBox="0 0 400 146"
      fill="none"
      aria-hidden="true"
    >
      <rect width="400" height="155" transform="matrix(-1 0 0 1 400 -3.55859)" fill={colors[0]} />
      <rect x="46" y="97.4414" width="51.4811" height="49.0001" fill={colors[1]} />
      <rect x="97.4814" y="48.4414" width="51.4811" height="49.0001" fill={colors[1]} />
      <rect x="148.962" y="-0.558594" width="51.4811" height="49.0001" fill={colors[1]} />
      <rect x="200" y="97.4414" width="51.4811" height="49.0001" fill={colors[1]} />
      <rect x="251.481" y="48.4414" width="51.4811" height="49.0001" fill={colors[1]} />
      <rect x="302.962" y="-0.558594" width="51.4811" height="49.0001" fill={colors[1]} />
    </svg>
  )
}
